import { object, string } from 'yup';
import { getTranslation } from '../../../../../../components/localization/customHooks/Translation';

const l10n = getTranslation();

const schema = object().shape({
  name: string().required(l10n.components.seasons.REQUIRED_FIELD),
  description: string(),
});

export default schema;
